import { render, staticRenderFns } from "./UploadMould.vue?vue&type=template&id=2e45d8ef&scoped=true&"
import script from "./UploadMould.vue?vue&type=script&lang=js&"
export * from "./UploadMould.vue?vue&type=script&lang=js&"
import style0 from "./UploadMould.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UploadMould.vue?vue&type=style&index=1&id=2e45d8ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45d8ef",
  null
  
)

export default component.exports